import { useMemo } from 'react';
import { isNil } from 'ramda';
import { useSearchContext } from './useSearch';

const isIncludedInSearch = (data, search) => {
  if (!data || !search) {
    return;
  }

  const keys = [
    'fields',
    'answer',
    'content',
    'sections',
    'subsections',
    'safetyWingCovers',
    'youCover',
    'data',
    'target',

    'question',
    'value',
    'title',
    'term',
    'name',
    'list'
  ];

  const recurse = (item, search, res = { found: undefined }) => {
    if (res.found) {
      return res.found;
    }

    if (Array.isArray(item)) {
      return item.map((x) => recurse(x, search, res)).find((x) => x === true);
    }

    if (typeof item === 'string') {
      if (item.trim().toLowerCase().includes(search.toLowerCase())) {
        res.found = true;
        return true;
      }

      return;
    }

    if (typeof item !== 'object') {
      return;
    }

    return Object.entries(item)
      .map(([key, value]) => {
        if (!keys.includes(key)) {
          return;
        }
        return recurse(value, search, res);
      })
      .find((x) => x === true);
  };

  const res = recurse(data, search);
  return Boolean(res);
};

const useSearchMatches = (data) => {
  const { debouncedSearch } = useSearchContext();

  const isSearchMatch = useMemo(() => {
    const match = isIncludedInSearch(data, debouncedSearch);
    if (isNil(match)) {
      return true;
    }
    return match;
  }, [data, debouncedSearch]);

  return {
    isSearchMatch
  };
};

export default useSearchMatches;
